function normalizePathname(pathname: string): string {
  const ensuredLeadingSlash = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return ensuredLeadingSlash.replace(/\/+$/, '') || '/';
}

const ATTRIBUTE_CODE_TO_ENTITY_LABEL: Readonly<Partial<Record<string, string>>> = {
  prdCategory: 'Category',
  prdBrand: 'Brand',
  prdNumber: 'Product',
  chnCountry: 'Country',
  chnMarketplace: 'Marketplace',
};

function getEntityLabelFromAttributeCode(attributeCode: string): string | undefined {
  return ATTRIBUTE_CODE_TO_ENTITY_LABEL[attributeCode];
}

export function getSteeringHubPageTitleFromPathname(pathname: string): string | undefined {
  const normalized = normalizePathname(pathname).replace(
    /^\/(trading|insightsfeed)(\/|$)/,
    '/steeringhub/insightsfeed$2'
  );

  if (normalized === '/steeringhub' || normalized === '/steeringhub/insightsfeed') {
    return 'Steering Hub | Insights Feed';
  }

  const match = normalized.match(/^\/steeringhub\/insightsfeed\/(detail|drilldown)\/([^/]+)/);
  if (!match) return undefined;

  const [, type, attributeCode] = match;
  const entity = getEntityLabelFromAttributeCode(attributeCode);
  if (!entity) return undefined;
  const suffix = type === 'detail' ? 'Detail' : 'Drilldown';

  return `Steering Hub | ${entity} ${suffix}`;
}
